import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { ThemeProvider } from "@/theme/ThemeProvider";
import Home from "@/pages/Home";
import Portfolio from "@/pages/Portfolio";
import CategoryDetail from "@/pages/CategoryDetail";
import ProjectDetail from "@/pages/ProjectDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Journal from "@/pages/Journal";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/portfolio/category/:categorySlug" element={<CategoryDetail />} />
            <Route path="/portfolio/:slug" element={<ProjectDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/journal" element={<Journal />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Toaster
            position="bottom-right"
            toastOptions={{
              className: "stxp-toast",
              style: {
                background: "var(--stxp-glass-strong)",
                backdropFilter: "blur(20px)",
                border: "1px solid var(--stxp-glass-border)",
                color: "var(--stxp-text)",
                fontFamily: "'Manrope', sans-serif",
                borderRadius: "9999px",
              },
            }}
          />
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
